import { Box, TextInput, TextInputProps } from '@mantine/core';

import InputLabel from 'components/input-label';
import classes from './index.module.css';

interface ICustomTextInput extends TextInputProps {
  info?: string;
  label?: string;
  ref?: any;
  variant?: string;
  labelLight?: boolean;
}

const CustomTextInput = ({
  info,
  label,
  required,
  ref,
  variant = '',
  labelLight = false,
  ...props
}: ICustomTextInput) => (
  <Box>
    {label ? <InputLabel label={label} light={labelLight} required={required} info={info} /> : undefined}
    <TextInput
      classNames={{ wrapper: classes.wrapper, input: `${classes.input} ${classes[variant]}`,  }}
      mb={6}
      withAsterisk={required}
      {...props}
      ref={ref}
    />
  </Box>
)

export default CustomTextInput;